import {QueryBuilderColumn, QueryBuilderColumnTypeEnum, QueryBuilderReducerDispatch, QueryBuilderStateQueryRule} from "../../../index";
import React, {FunctionComponent, useMemo} from "react";
import QueryBuilderValueInputString from "./string";
import QueryBuilderValueInputNumber from "./number";
import QueryBuilderValueInputCheckbox from "./checkbox";
import QueryBuilderValueInputDate from "./date";
import QueryBuilderValueInputList from "./list";

export interface QueryBuilderValueInputProps {
    column: QueryBuilderColumn;
    rule: QueryBuilderStateQueryRule;
    ruleIndex: number;
    conditionIndex: number;
    disabled: boolean;
    dispatch: QueryBuilderReducerDispatch;
}

const QueryBuilderValueInput: FunctionComponent<QueryBuilderValueInputProps> = ({
                                                                                    column,
                                                                                    rule,
                                                                                    ruleIndex,
                                                                                    conditionIndex,
                                                                                    dispatch,
                                                                                    disabled,
                                                                                }) => {
    const type = useMemo(() => column.type, [column])

    switch (type) {
        case QueryBuilderColumnTypeEnum.String:
            return (
                <QueryBuilderValueInputString
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        case QueryBuilderColumnTypeEnum.Int:
            return (
                <QueryBuilderValueInputNumber
                    allowDecimal={false}
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        case QueryBuilderColumnTypeEnum.Decimal:
            return (
                <QueryBuilderValueInputNumber
                    allowDecimal
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        case QueryBuilderColumnTypeEnum.Bool:
            return (
                <QueryBuilderValueInputCheckbox
                    column={column}
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        case QueryBuilderColumnTypeEnum.List:
            return (
                <QueryBuilderValueInputList
                    column={column}
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            )
        case QueryBuilderColumnTypeEnum.Date:
            return (
                <QueryBuilderValueInputDate
                    allowDate
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        case QueryBuilderColumnTypeEnum.Time:
            return (
                <QueryBuilderValueInputDate
                    allowTime
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        case QueryBuilderColumnTypeEnum.DateTime:
            return (
                <QueryBuilderValueInputDate
                    allowDate
                    allowTime
                    rule={rule}
                    ruleIndex={ruleIndex}
                    conditionIndex={conditionIndex}
                    disabled={disabled}
                    dispatch={dispatch}
                />
            );
        default:
            return null;
    }
}

export default QueryBuilderValueInput;
